module.exports = __webpack_public_path__ + "img/treatment-icon-orange.bd41a46d.svg";